module.exports = __webpack_public_path__ + "static/media/paraicon3.5301d128.webp";